import { pageContext } from 'ctm-util-functions';

/**
 * Determine whether changing this filter needs to show the update button.
 * Always show the update button on XS.
 * @param {Object} filterProps The filters properties
 * @returns {Boolean} True or False depending on whether we should be showing the update button.
 */
const getFilterStaged = (filterProps) => {
    const { showUpdateButton = false } = filterProps;
    const isXsBreakpoint = pageContext.getProps().pageState.breakpoint === 'xs';
    return isXsBreakpoint ? true : showUpdateButton;
};

/**
 * Trigger the onChange event to apply the filter values and determine whether to show
 * the update button
 * @param {Event} event - The event object
 * @param {Object} props - The props for the component calling this function
 * @param {Boolean} showUpdateButton - an optional flag that can be used to not show the update button - this is used
 * when the 'Custom' option is selected in the RadioFilter, we want to only show the update button when a custom value has been entered
 */
const onChange = (event, props, showUpdateButton = true) => {
    const { fetchNewResults, resultsStateKey, filter, formStateKey, resultsStagedStateKey } = props.filterProps;
    const filterStaged = getFilterStaged(props.filterProps);
    props.dispatch({
        type: 'SET_FILTER_VALUE',
        filter,
        filterStaged,
        filterValue: event.target.value
    });

    const resultsConfigActions = [];
    if (fetchNewResults) {
        resultsConfigActions.push(
            {
                key: 'filters.fetchNewResults',
                value: true
            }
        );
    }
    if (filterStaged) {
        if (showUpdateButton) {
            resultsConfigActions.push({
                key: 'filters.showFiltersUpdateButton',
                value: true
            });
        }

        props.dispatch({
            type: 'SET_FILTER_ACTION',
            resultsStateKey,
            resultsStagedStateKey,
            formStateKey
        });
    }

    if (resultsConfigActions.length) {
        props.dispatch({
            type: 'SET_RESULTS_CONFIG_VALUES',
            actions: resultsConfigActions
        });
    }
};

export {
    getFilterStaged,
    onChange
};
